// extracted by mini-css-extract-plugin
var _1 = "XyymB";
var _2 = "a_Fbk";
var _3 = "YaifU";
var _4 = "soSmp";
var _5 = "WQLxb";
var _6 = "NGE9k";
var _7 = "hhU6i";
export { _1 as "base", _2 as "error", _3 as "icon", _4 as "message", _5 as "theme-dark", _6 as "theme-light", _7 as "warning" }
